import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../App.css";
import MedicationResources from "../MedicationResources";
import Disclaimer from "../components/Disclaimer";
import { medications } from "../data/medicationData";
import TopBar from "../components/TopBar"; // ← new, provides breadcrumb + avatar/login + white nav + modals

const Medications = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const treatmentFromSearch = queryParams.get("treatment");

  const defaultMedication = treatmentFromSearch || Object.keys(medications)[0];
  const [selectedMedication, setSelectedMedication] = useState(defaultMedication);
  const [selectedSummary, setSelectedSummary] = useState(null);
  const [showTreatmentSelector, setShowTreatmentSelector] = useState(true);

  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  useEffect(() => {
    if (treatmentFromSearch && medications[treatmentFromSearch]) {
      setSelectedMedication(treatmentFromSearch);
    }
  }, [treatmentFromSearch]);

  if (!medications[selectedMedication]) {
    return <h2>Error: Medication not found.</h2>;
  }

  const { name, description, cost, insuranceCoverage, resources } = medications[selectedMedication];

  const handleViewSummary = (summary) => {
    setSelectedSummary(summary);
  };

  const handleCloseSummary = () => {
    setSelectedSummary(null);
  };

  return (
    <div className="page-container">
      <TopBar breadcrumb={`Medications > ${medications[selectedMedication]?.name}`} />

      <div className="medications-container">
        {isMobile && showTreatmentSelector && (
          <div className="treatment-selector-overlay">
            <div className="overlay-header">
              <button className="back-button" onClick={() => navigate("/")}>
                ← Back
              </button>
              <h2>Medications</h2>
            </div>
            <div className="overlay-treatments">
              {Object.keys(medications).map((med) => (
                <div
                  key={med}
                  className={`category-card ${selectedMedication === med ? "active" : ""}`}
                  onClick={() => {
                    setSelectedMedication(med);
                    navigate(`/medications?treatment=${encodeURIComponent(med)}`);
                    setShowTreatmentSelector(false);
                  }}
                >
                  <h3>{medications[med].name}</h3>
                </div>
              ))}
            </div>
          </div>
        )}

        {isMobile && !showTreatmentSelector && (
          <button
            className="select-treatment-button"
            onClick={() => setShowTreatmentSelector(true)}
          >
            Select a Treatment
          </button>
        )}

        <div className="medication-layout">
          <div className="sidebar">
            <h2 className="sidebar-title">Medications</h2>
            <p className="sidebar-description">
              Explore treatments commonly prescribed for chronic pain.
            </p>
            <div className="sidebar-blocks">
              {Object.keys(medications).map((med) => (
                <div
                  key={med}
                  className={`category-card ${selectedMedication === med ? "active" : ""}`}
                  onClick={() => {
                    setSelectedMedication(med);
                    navigate(`/medications?treatment=${encodeURIComponent(med)}`);
                  }}
                >
                  <h3>{medications[med].name}</h3>
                </div>
              ))}
            </div>
          </div>

          <div className="main-content">
            <div className="medication-info-box">
              <h2 className="medication-title">{name}</h2>
              <p className="medication-description">{description}</p>
              {cost && (
                <p className="medication-info">
                  <strong>Cost:</strong> {cost}
                </p>
              )}
              {insuranceCoverage && (
                <p className="medication-info">
                  <strong>Insurance Coverage:</strong> {insuranceCoverage}
                </p>
              )}
            </div>

            <div className="research-box">
              <h3 className="resources-title">Research on Treatment Outcomes</h3>
              <MedicationResources resources={resources} onViewSummary={handleViewSummary} />
            </div>
          </div>
        </div>

        {selectedSummary && (
          <div className="summary-modal">
            <div className="modal-content">
              <button className="close-button" onClick={handleCloseSummary}>
                ×
              </button>
              <h3 style={{ textAlign: "left" }}>Summary</h3>
              <div className="summary-scroll">
                <p className="sidebar-description-left">{selectedSummary}</p>
              </div>
            </div>
          </div>
        )}
      </div>

      <Disclaimer />
    </div>
  );
};

export default Medications;
